import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { PowerPlayerBolt } from '../../assets/powerPlayerBolt';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { ROOM_INFO_PANEL_LIST_ITEM_DIVIDER_COLOR, ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR } from '../../styles/colors';
import { assertUnreachable } from '../../utils/tsUtils';
import { PanelItem } from '../panelItem';
import { PanelItemDivider } from '../panelItemDivider';
export function selectPlayersArray(state) {
    const { roomSceneType } = state.scene;
    if (!roomSceneType) {
        return;
    }
    switch (roomSceneType) {
        case 'lobby': {
            return state.lobby.lobbyPlayers;
        }
        case 'poker': {
            return state.poker.players;
        }
        case 'mttStaging': {
            return state.mttStaging.players;
        }
        default: {
            assertUnreachable(roomSceneType);
        }
    }
}
function selectPlayerAtIndex(state, playerIndex) {
    return selectPlayersArray(state)?.[playerIndex];
}
export const PlayerPanelItem = ({ playerIndex }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const playerIdName = useAppSelector((state) => {
        const player = selectPlayerAtIndex(state, playerIndex);
        if (!player) {
            return;
        }
        return { id: player.id, name: player.name };
    }, shallowEqual);
    const isPowerPlayer = useAppSelector((state) => selectPlayerAtIndex(state, playerIndex)?.isPowerPlayer);
    const onClick = useCallback(() => {
        if (!playerIdName) {
            return;
        }
        dispatch(thunkShowPlayerInfo(playerIdName, socketSend));
    }, [dispatch, playerIdName, socketSend]);
    if (!playerIdName) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(PanelItem, { onClick: onClick, hoverColor: ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR, children: [playerIdName.name, isPowerPlayer && _jsx(PowerPlayerBolt, { color: 'black', size: 'small', isSubtle: true })] }), _jsx(PanelItemDivider, { color: ROOM_INFO_PANEL_LIST_ITEM_DIVIDER_COLOR })] }));
};
